import { render, staticRenderFns } from "./SublessonOverview.vue?vue&type=template&id=9b5ecdde&scoped=true&"
import script from "./SublessonOverview.vue?vue&type=script&lang=ts&"
export * from "./SublessonOverview.vue?vue&type=script&lang=ts&"
import style0 from "./SublessonOverview.vue?vue&type=style&index=0&id=9b5ecdde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5ecdde",
  null
  
)

export default component.exports